module.exports = __webpack_public_path__ + "templates.dialog.member_referral_rule-61f95eb4.html";